module.exports = __webpack_public_path__ + "img/pic3.bfc2fb90.png";